import groq from 'groq';

import { ASSET } from './asset';
import { CLOUDINARY_VIDEO } from './cloudinaryVideo';

export const MEDIA = groq`
  media[]{
    _type,
    _type == 'background' => {
      image {
        ${ASSET},
        hotspot,
        crop
      },
      gradientOverlay {
        desktop,
        mobile
      },
    },
    _type == 'video' => {
      ${CLOUDINARY_VIDEO},
      gradientOverlay {
        desktop,
        mobile
      },
    },
  }
`;
